/* oxlint-disable lingui/no-unlocalized-strings */
// Don't translate for single language organizations
import { Text } from "@medoma/components/Text/Text";

export const GuideTemplateHahag = () => {
  return (
    <>
      <Text element="p">Willkommen im Spital zu Hause.</Text>

      <Text element="p">
        Das Team der Hospital at Home AG bietet Ihnen bei akuten Erkrankungen
        professionelle medizinische Behandlung und Betreuung im Komfort des
        eigenen Zuhauses.
      </Text>

      <Text element="p">
        Wir besuchen Sie täglich ärztlich und pflegerisch, verabreichen die
        erforderlichen Medikamente inklusive Infusionen und machen bei Bedarf
        Diagnostik wie Blutentnahmen, EKG und Ultraschall direkt bei Ihnen zu
        Hause.
      </Text>

      <Text element="p">
        Während der Visiten hat unser medizinisches Fachpersonal viel Zeit, den
        Therapieplan zu besprechen und Ihre Fragen zu beantworten.
      </Text>

      <Text element="p">
        Diese App bietet Ihnen Informationen über Ihre Behandlungsverlauf, über
        den Zeitpunkte der Visiten, welche Fachperson Sie besuchen wird, und
        vieles mehr. Zudem können Sie über die Chatfunktion (direkt in dieser
        App) oder über das Telefon 044 455 33 03 rund um die Uhr mit uns in
        Kontakt treten.
      </Text>

      <Text element="p">Wir wünschen Ihnen rasche und gute Besserung.</Text>

      <Text element="p">Ihr Hospital at Home Team</Text>
    </>
  );
};
